import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import { Typography } from "antd";
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';  
import { list, aggregatedList } from "../../../../controllers/V1/lottoWinners/lottoWinnersControllers";
import Loading from "../../../../components/Loading/LoadingEffect";
import { Link } from "react-router-dom";
import moment from "moment";
import { formatProjectDate } from "../../../../controllers/common";
import {list as generalData} from "../../../../controllers/V1/cms/generalDataController";

const VendorListDeletePopUp = ({ popUpOpen, togglePopUp }) => {
  const handleCancel = () => {
    togglePopUp();
    setBigWinners("Winners List");
  }

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const [todayDate, setTodayDate] = useState(moment().format('YYYY-MM-DD') || '');
  const [todayTime, setTodayTime] = useState('21:31:00');
  const [yesterdayDate, setYesterdayDate] = useState(`${moment().subtract(1,'days').format('YYYY-MM-DD')}`);
  const [yesterdayTime, setYesterdayTime] = useState('21:30:00');
  const [bigWinners, setBigWinners] = useState("Winners List");
  const handleDateTimeChange = (e)=>{
    const {name, value} = e.target;
    if(name === 'valid_date'){
      setYesterdayDate(value)
    } else if(name === 'valid_time'){
      setYesterdayTime(value)
    } else if(name === 'expire_date'){
      setTodayDate(value)
    } else if(name === 'expire_time'){
      setTodayTime(value)
    }
  }


  const handleExport = async (e) => {
    e.preventDefault(); // Prevent the default form submission
    if(bigWinners === "Big Winners"){
      handleBigWinners(e);
      return;
    } 

    setError(null); // Reset the error state before each request
    try {
      setIsLoading(true);
      const formData = new FormData(e.target);
      // const today = new Date();
      // let from_date = formData.get('from_date');
      // let to_date = formData.get('to_date');

      // if(from_date && !to_date){
      //   to_date = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
      // }
      const option = {
        isExport : true,
        condition: {
          ...(formData.get("batch_id") && { batch_id: parseInt(formData.get("batch_id")) } ),
          ...(formData.get("order_no") && { order_no: formData.get("order_no") } ),

          ...(formData.get("seller_first_name") && { seller_first_name: { $regex: formData.get("seller_first_name"), $options: "i" } } ),
          ...(formData.get("seller_last_name") && { seller_last_name: { $regex: formData.get("seller_last_name"), $options: "i" } } ),
          ...(formData.get("seller_mobile") && { seller_mobile: parseInt(formData.get("seller_mobile")) } ),

          ...(formData.get("coupon_code") && { coupon_code: parseInt(formData.get("coupon_code")) } ),
          ...(formData.get("matching_code") && { matching_code: parseInt(formData.get("matching_code")) } ),
          ...(formData.get("winner_type") && { winner_type: { $regex: formData.get("winner_type"), $options: "i" } } ),
          ...(formData.get("winning_amount") && { winning_amount: parseInt(formData.get("winning_amount")) } ),

          ...(formData.get("redeem_name") && { redeem_name: { $regex: formData.get("redeem_name"), $options: "i" } } ),
          ...(formData.get("redeem_pos") && { redeem_pos: parseInt(formData.get("redeem_pos")) } ),

          ...(formData.get("status") && { status: formData.get("status") } ),
          
          // ...((from_date && to_date) && {createdAt : {$gte : `${from_date} 21:30:59`, $lte : `${to_date} 21:29:59`}  }),
          ...(formData.get("status") === 'Redeemed' && {createdAt : {$gte : `${yesterdayDate} ${yesterdayTime}`, $lte : `${todayDate} ${todayTime}`}})
          
        },
        select: {
          "batch_id": true,
          "order_no": true,
          "seller_first_name": true,
          "seller_last_name": true,
          "seller_mobile": true,
          "coupon_code": true,
          "matching_code": true,
          "straight_amount": true,
          "rumble_amount": true,
          "chance_amount": true,
          "winner_type": true,
          "winning_amount": true,
          "draw_date": true,
          "file": true,
          "status": true,
          "redeem_date" : true,
          "redeem_name" : true,
          "redeem_pos" : true,
          "created_by": true,
          "order_details": true
        },
        sort : {redeem_date : -1}
      };

      // Make the API call
      // const res = await list(option);
      const res = await aggregatedList(option);
      if (res.status === true) {
        if(res.result.length > 0){
          let modifiedData = res?.result.map(({ _id, redeem_date, ...rest }) => ({
            // ...rest,
            "Batch ID" : rest?.batch_id,
            "Order No" : rest?.order_no,
            "Seller First Name" : rest?.seller_first_name,
            "Seller Last Name" : rest?.seller_last_name,
            "Seller Mobile" : rest?.seller_mobile,
            "Bind With"   : rest?.order_details?.bind_person_name || 'N/A',
            "Area"        : rest?.order_details?.seller_area || 'N/A',
            "Game Name"   : rest?.order_details?.campaign_title || 'N/A',
            "Draw Date"   : moment(rest?.order_details?.draw_date_time).format('DD-MM-YYYY') || 'N/A',
            "Coupons" : rest?.coupon_code,
            "Matching Code" : rest?.matching_code,
            "Winner Type" : rest?.winner_type,
            "Winning Amount" : rest?.winning_amount,
            ...(rest?.order_details?.createdAt?{
              "Purchase Date" : moment(formatProjectDate(rest?.order_details?.createdAt)).format('DD-MM-YYYY HH:mm')
            }:{
              "Purchase Date" : '--',
            }),
            "Status" : rest?.status,
            "Redeem Name" : rest?.redeem_name,
            "Redeem POS" : rest?.redeem_pos,
            ...(redeem_date && {'Redeem Date' : moment(formatProjectDate(redeem_date)).format('DD-MM-YYYY hh:mm A') || ''})
          }));
          await exportToExcel(modifiedData); 
        }
        handleCancel(); // Reset the form or close modal
      } else {
        setIsLoading(false);
        setError("No records found matching the criteria.");
      }
    } catch (error) {
      setIsLoading(false);
      setError("An error occurred while exporting the data.");
      console.error("Export Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBigWinners = async (e) => {
    e.preventDefault();
    setError(null); // Reset the error state before each request
    try {
      setIsLoading(true);
      const option = {
        isExport : true,
        condition: {
          createdAt : {$gte : `${yesterdayDate} ${yesterdayTime}`, $lte : `${todayDate} ${todayTime}`},
        },
        select : {
          _id: 1,
          order_no: 1,
          seller_first_name : 1,
          seller_last_name : 1,
          seller_mobile : 1,
          winning_amount : 1,
          order_details : 1,
          createdAt : 1
        },
        sort : { winning_amount : -1 }
      };
      const res = await aggregatedList(option);
      if (res.status === true) {
        if(res.result.length > 0){
          let modifiedData = res?.result.map((items, index) => ({
            "Sl. No."     : index + 1,
            "Order ID"    : items?.order_no,
            "Retailers"   : `${items?.seller_first_name} ${items?.seller_last_name}`,
            "POS No."     : items?.order_details?.seller_pos_number || 'N/A',
            "Draw Date"   : moment(items?.order_details?.draw_date_time).format('DD-MM-YYYY') || 'N/A',
            "Game Name"   : items?.order_details?.campaign_title || 'N/A',
            "Prize Money" : items?.winning_amount || '0',
            ...(items?.order_details?.createdAt?{
              "Purchase Date" : moment(formatProjectDate(items?.order_details?.createdAt)).format('DD-MM-YYYY HH:mm')
            }:{
              "Purchase Date" : '--',
            }),
            "Area"        : items?.order_details?.seller_area || 'N/A',
            "Bind With"   : items?.order_details?.bind_person_name || 'N/A',
          }));
          await exportToExcel(modifiedData); 
        }
        handleCancel(); // Reset the form or close modal
      } else {
        setIsLoading(false);
        setError("No records found matching the criteria.");
      }
    } catch (error) {
      setIsLoading(false);
      setError("An error occurred while exporting the data.");
      console.log("Export Error:", error);
    } finally {
      setIsLoading(false);
    }
  }

  const exportToExcel = async (data) => {
    try {
      const workbook = XLSX.utils.book_new();
      const worksheet1 = XLSX.utils.json_to_sheet(data);

      XLSX.utils.book_append_sheet(workbook, worksheet1, "Due");
      XLSX.writeFile(workbook, `B-Winn Winner's List ${new Date()}.xlsx`);
    } catch (error) {
      alert("Error generating Excel file: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

    const getGeneralData = async () => {
      try {
        const option ={}
        const res = await generalData(option);
        if(res?.status === true){
          const time = moment().endOf('day').format('HH:mm');
          const startTime = res?.result?.export_start_time;
          const endTime = res?.result?.export_end_time;
          setTodayTime(endTime || time);
          setYesterdayTime(startTime || time);
        }
      } catch (error) {
        
      }
    }
  
    useEffect(()=>{
      getGeneralData();
    },[])

  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"md"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        <div className="inventory_popup_title">
          <Typography variant="h5" component="div" gutterBottom className="inventory_popup_title_heading">
            Export Lotto Winners
          </Typography>
          <Link to={false} style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }} onClick={handleCancel}>
            <FontAwesomeIcon icon={faTimesCircle} />
          </Link>
        </div>

        <Typography variant="body1" component="div" className="my_delete_popup_paragraph">
          <div className="container-fluid">
            <div className="categories_open_popup_main_contnet">
              <form onSubmit={handleExport}>
                <div className="form-group row">
                  <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <label htmlFor="order_no" className="all_lable_for_vendor_dashbaord">Export Type :</label>
                    <select name="bigWinners" id="bigWinners" onChange={(e)=>setBigWinners(e.target.value)} className="form-control categories_select_tg_enter_product" >
                      <option value="Winners List" selected={bigWinners === "Winners List" ? true : false}>Winners List</option>
                      <option value="Big Winners" selected={bigWinners === "Big Winners" ? true : false}>Big Winners</option>
                    </select>
                  </div>
                  {bigWinners === "Winners List" && (
                    <>
                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                      <label htmlFor="order_no" className="all_lable_for_vendor_dashbaord">Order No :</label>
                      <input type="text" name="order_no" id="order_no" placeholder="Order No" className="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                      <label htmlFor="batch_id" className="all_lable_for_vendor_dashbaord">Batch No :</label>
                      <input type="text" name="batch_id" id="batch_id" placeholder="Batch No." className="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                      <label htmlFor="points" className="all_lable_for_vendor_dashbaord">Points :</label>
                      <input type="text" name="points" id="points" placeholder="Points" className="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                      <label htmlFor="seller_first_name" className="all_lable_for_vendor_dashbaord">Seller's First Name :</label>
                      <input type="text" name="seller_first_name" id="seller_first_name" placeholder="Seller's First Name" className="form-control categories_select_tg_enter_product" />
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                      <label htmlFor="seller_last_name" className="all_lable_for_vendor_dashbaord">Seller's Last Name :</label>
                      <input type="text" name="seller_last_name" id="seller_last_name" placeholder="Seller's Last Name" className="form-control categories_select_tg_enter_product" />
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                      <label htmlFor="seller_mobile" className="all_lable_for_vendor_dashbaord">Seller's Mobile :</label>
                      <input type="text" name="seller_mobile" id="seller_mobile" placeholder="Seller's Mobile" className="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                      <label htmlFor="coupon_code" className="all_lable_for_vendor_dashbaord">Coupon Code :</label>
                      <input type="text" name="coupon_code" id="coupon_code" placeholder="Coupon Code" className="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                      <label htmlFor="matching_code" className="all_lable_for_vendor_dashbaord">Matching Code :</label>
                      <input type="text" name="matching_code" id="matching_code" placeholder="Matching Code" className="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                      <label htmlFor="winner_type" className="all_lable_for_vendor_dashbaord">Winner Type :</label>
                      <input type="text" name="winner_type" id="winner_type" placeholder="Winner Type" className="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                      <label htmlFor="winning_amount" className="all_lable_for_vendor_dashbaord">Winning Amount :</label>
                      <input type="text" name="winning_amount" id="winning_amount" placeholder="Winning Amount" className="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                      <label htmlFor="redeem_name" className="all_lable_for_vendor_dashbaord">Redeem By Name :</label>
                      <input type="text" name="redeem_name" id="redeem_name" placeholder="Redeem By Name" className="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                      <label htmlFor="redeem_pos" className="all_lable_for_vendor_dashbaord">Redeem By POS :</label>
                      <input type="text" name="redeem_pos" id="redeem_pos" placeholder="Redeem POS" className="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                      <label htmlFor="status" className="all_lable_for_vendor_dashbaord">Status :</label>
                      <select name="status" id="status" placeholder="Status" className="form-control categories_select_tg_enter_product" >
                        {/* <option value='' selected disabled >Select status</option> */}
                        <option value={'Active'}>Active</option>
                        <option value={'Expired'}>Expired</option>
                        <option value={'Redeemed'} selected>Redeemed</option>
                        <option value={''} >All</option>
                      </select>
                    </div>
                    </>
                  )}
                  
                  <div className="row">
                    <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                      <label
                        htmlFor="valid_date"
                        className="all_lable_for_vendor_dashbaord"
                      >
                        From :
                      </label>
                      <input
                        type="date"
                        name="valid_date"
                        id="valid_date"
                        value={yesterdayDate}
                        onChange={handleDateTimeChange}
                        className="form-control categories_select_tg_enter_product"
                      />
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                      <label
                        htmlFor="valid_time"
                        className="all_lable_for_vendor_dashbaord"
                      >
                        Time :
                      </label>
                      <input
                        type="time"
                        name="valid_time"
                        id="valid_time"
                        value={yesterdayTime}
                        onChange={handleDateTimeChange}
                        className="form-control categories_select_tg_enter_product"
                      />
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                      <label
                        htmlFor="expire_date"
                        className="all_lable_for_vendor_dashbaord"
                      >
                        To :
                      </label>
                      <input
                        type="date"
                        name="expire_date"
                        id="expire_date"
                        value={todayDate}
                        onChange={handleDateTimeChange}
                        className="form-control categories_select_tg_enter_product"
                      />
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                      <label
                        htmlFor="expire_time"
                        className="all_lable_for_vendor_dashbaord"
                      >
                        Time :
                      </label>
                      <input
                        type="time"
                        name="expire_time"
                        id="expire_time"
                        value={todayTime}
                        onChange={handleDateTimeChange}
                        className="form-control categories_select_tg_enter_product"
                      />
                    </div>
                  </div>

                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="inventory_open_popup_action_btn">
                      <button type="button" className="btn btn-light categories_cancel_button" onClick={handleCancel}>Cancel</button>
                      <button type="submit" className="btn btn-danger" disabled={isLoading}>Download Excel</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Typography>
        {error && <div style={{ color: 'red' }}>{error}</div>}
      </div>
      <Loading isLoading={isLoading} text={`Preparing download...`} />
    </Dialog>
  );
};

export default VendorListDeletePopUp;
